"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAzMapping = getAzMapping;
exports.getRegionAndAzList = getRegionAndAzList;
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var axios = new _axios.default();
// 通过serviceCode获取az配置(供iaas测使用)
//http://xingyun.jd.com/codingRoot/jcloud-api-gateway/jcloud-open-api-doc/blob/internal/resourcecenter/%E8%B5%84%E6%BA%90%E4%B8%AD%E5%BF%83%E5%8F%AF%E7%94%A8%E5%8C%BA%E9%85%8D%E7%BD%AE%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getAzMapping.md
function getAzMapping(serviceCode) {
  return axios({
    url: '/openApi/resourcecenter/getAzMapping',
    method: 'GET',
    params: {
      params: {
        serviceCode: serviceCode
      }
    }
  });
}

// http://xingyun.jd.com/codingRoot/jcloud-api-gateway/jcloud-open-api-doc/blob/internal/resourcecenter/%E8%B5%84%E6%BA%90%E4%B8%AD%E5%BF%83%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/getRegionAndAzList.md

function getRegionAndAzList() {
  return axios({
    url: '/openApi/resourcecenter/getRegionAndAzList',
    method: 'GET'
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/resourcecenter.js
// module id = gKOB
// module chunks = 19